import { render, staticRenderFns } from "./productCategory.html?vue&type=template&id=59b544ac&scoped=true&"
import script from "./productCategory.vue?vue&type=script&lang=js&"
export * from "./productCategory.vue?vue&type=script&lang=js&"
import style0 from "./productCategory.vue?vue&type=style&index=0&id=59b544ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b544ac",
  null
  
)

export default component.exports